import React, { useContext } from "react";

import { useTheme } from "@mui/material/styles";
import makeStyles from '@mui/styles/makeStyles';
import Typography from "@mui/material/Typography";
import { DialogContentText, IconButton } from "@mui/material";
import Grid from "@mui/material/Grid";

import LanguageContext from "../../LanguageContext";
import messages from "../../services/messages";

import DialogTitle from "@mui/material/DialogTitle";
import config from "../../config";
import { Close } from "@mui/icons-material";
import DialogContent from "@mui/material/DialogContent";

import Dialog from "@mui/material/Dialog";

import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";

const useStyles = makeStyles((theme) => ({
  title: {
    marginBottom: theme.spacing(-1),
  },
  titleIcon: {
    height: theme.spacing(3),
    marginTop: theme.spacing(0.5),
  },
  titleText: {
    marginLeft: theme.spacing(1),
    fontWeight: "bold",
  },
  actions: {
    marginBottom: theme.spacing(1),
    marginTop: theme.spacing(-1),
  },
  closeButton: {
    marginTop: theme.spacing(-1),
    marginLeft: theme.spacing(1),
  },
  body: {
    color: "black",
  },
}));

export default function LeadDialog(props) {
  const classes = useStyles();
  const language = useContext(LanguageContext);

  const theme = useTheme();

  return <>
    <Dialog
      fullWidth={true}
      onClose={props.handleClose}
      aria-labelledby="title"
      open={props.open}
    >
      <DialogTitle className={classes.title}>
        <Grid container direction="row" justifyContent="center" alignItems="center">
          <Grid item xs={5}></Grid>
          <Grid item xs={1}>
            <img
              className={classes.titleIcon}
              src={`${config.appUrl}/icons/namaste.png`}
              alt=""
            />
          </Grid>
          <Grid item xs={4}></Grid>
          <Grid item xs={2}>
            <IconButton
              edge="end"
              aria-label="close"
              onClick={props.handleClose}
              className={classes.closeButton}
              color="inherit"
              size="large">
              <Close />
            </IconButton>
          </Grid>
        </Grid>
      </DialogTitle>
      <DialogContent>
        <DialogContentText className={classes.body}>
          <Typography variant={"body1"} align={"center"}>
            {messages["dashboard.leadRegistrationSuccess.message"][language]}
          </Typography>
        </DialogContentText>
      </DialogContent>
      <DialogActions className={classes.welcomeDialogActions}>
        <Grid container direction="row" justifyContent="center" alignItems="center">
          <Grid item>
            <Button
              onClick={props.handleClose}
              variant={"contained"}
              color="primary"
              fullWidth={true}
            >
              {messages["dashboard.leadRegistrationSuccess.okay"][language]}
            </Button>
          </Grid>
        </Grid>
      </DialogActions>
    </Dialog>
  </>;
}
